// extracted by mini-css-extract-plugin
module.exports = {"form":"Briefing_form__2JJWc","file_title":"Briefing_file_title__3oXIf","file_reset_button":"Briefing_file_reset_button__3jNaW"};